import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { ISetUnavailableSlotsByTokenPayload } from '@app-store/slices/sharedLists/setUnavailableSlotsByToken'
interface TaskAction extends Action {
    payload: ISetUnavailableSlotsByTokenPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.sharedLists.setUnavailableSlotsByToken

function* setUnavailableSlotsByTokenSagaTask({ payload }) {
    try {
        const response = yield axios.post(`/meeting/unavailable/by-token?token=${payload.token}`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload.sagaCB?.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        // console.log(error)
        yield put(onFailure(error))
    }
}

function* setUnavailableSlotsByTokenSaga(): any {
    yield takeLatest<TaskAction>(onRequest, setUnavailableSlotsByTokenSagaTask)
}

export default setUnavailableSlotsByTokenSaga
